<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Summary Bar
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2 *ngIf="isBrowser">Customized Summary Bar</h2>
  <div class="content__tools-wrap" *ngIf="isBrowser">
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="hasLabel" class="c-input-check-inline__input" type="checkbox" name="hasLabel"
          [(ngModel)]="hasLabel" />
        <label for="hasLabel" class="c-input-check-inline__label">Has Label</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasMetaData" class="c-input-check-inline__input" type="checkbox" name="hasMetaData"
          [(ngModel)]="hasMetaData" />
        <label for="hasMetaData" class="c-input-check-inline__label">Has Meta Data</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasLink" class="c-input-check-inline__input" type="checkbox" name="hasLink" [(ngModel)]="hasLink" />
        <label for="hasLink" class="c-input-check-inline__label">Has link</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasToggle" class="c-input-check-inline__input" type="checkbox" name="hasToggle"
          [(ngModel)]="hasToggle" />
        <label for="hasToggle" class="c-input-check-inline__label">Has Toggle</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasLableIcon" class="c-input-check-inline__input" type="checkbox" name="hasLableIcon"
          [(ngModel)]="hasLableIcon" />
        <label for="hasLableIcon" class="c-input-check-inline__label">Has Lable Icon</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasTooltip" class="c-input-check-inline__input" type="checkbox" name="hasTooltip"
          [(ngModel)]="hasTooltip" />
        <label for="hasTooltip" class="c-input-check-inline__label">Has Tooltip</label>
      </div>
    </div>
    <div class="content__row">
      <input id="label" class="c-input-group__control" placeholder="Label" type="text" name="label"
        [(ngModel)]="label" />
      <label for="label" class="u-display-none">label</label>
    </div>
  </div>
  <h2>Summary Bar design view</h2>
  <maced-summary-bar summaryBarId="summaryBarId" class="c-summary-bar-outer">
    <ng-container ngProjectAs="[summaryBarDescription]">
      <ng-container *ngIf="!isMobileView">
        <div class="c-summary-bar__content-outer">
          <div class="c-summary-bar__content">
            <ul class="c-summary-bar__list" role="list">
              <li class="c-summary-bar__list-item" *ngIf="hasLabel" role="listitem">
                <span class="c-summary-bar__list-item-label">Label:</span>
                {{ label }}
                <span *ngIf="hasLableIcon" class="c-summary-bar__list-item-value">
                  <em #tooltipTargetReference class="u-icon icon-info-circle c-summary-bar__list-item-icon"
                    [attr.role]="message?'img': ''" [attr.aria-label]="message" [attr.alt]="message"></em>
                  <maced-tooltip id="tooltip1" *ngIf="hasTooltip" [placement]="selectedPlacement" [hasCaret]="hasCaret"
                    [tooltipTargetReference]="tooltipTargetReference" [message]="message">
                  </maced-tooltip>
                </span>
              </li>
              <ng-container *ngIf="hasMetaData">
                <li class="c-summary-bar__list-item" *ngFor="let data of metaData" role="listitem">
                  {{ data }}
                </li>
              </ng-container>
              <li class="c-summary-bar__list-item" *ngIf="hasLink" role="listitem">
                <maced-link id="linkId1" [links]="link1" [showNextIconClass]="true" [nextIconClass]="nextIconClass">
                </maced-link>
              </li>
              <li class="c-summary-bar__list-item" *ngIf="hasToggle" role="listitem">
                <maced-toggle name="toggle1" id="toggle1" [textOn]="toggleText" class="c-summary-bar__list-item-toggle"
                  [ariaLabel]="
                    toggleNgModel
                        ? 'toggle button switch on'
                        : 'toggle button switch off'
                    " [(ngModel)]="toggleNgModel">
                </maced-toggle>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isMobileView">
        <maced-accordian-group accordianGroupId="accordianGroupId">
          <maced-accordian accordianId="accordianId1" [collapseLabel]="collapseLabel" [expandLabel]="expandLabel"
            [hasDefaultExpanded]="hasDefaultExpanded">
            <div ngProjectAs="[accordionContent]" class="c-summary-bar__content">
              <ul class="c-summary-bar__list" role="list">
                <li class="c-summary-bar__list-item" *ngIf="hasLabel" role="listitem">
                  <span class="c-summary-bar__list-item-label">Label:</span>
                  {{label}}
                  <span *ngIf="hasLableIcon">
                    <em #tooltipTargetReference title="info icon"
                      class="u-icon icon-info-circle c-summary-bar__list-item-icon" [attr.role]="message?'img': ''" [attr.aria-label]="message" [attr.alt]="message"></em>
                    <maced-tooltip id="tooltip1" *ngIf="hasTooltip" [placement]="selectedPlacement"
                      [hasCaret]="hasCaret" [tooltipTargetReference]="tooltipTargetReference" [message]="message">
                    </maced-tooltip>
                  </span>
                </li>
                <ng-container *ngIf="hasMetaData">
                  <li class="c-summary-bar__list-item" *ngFor="let data of metaData" role="listitem">
                    {{data}}
                  </li>
                </ng-container>
                <li class="c-summary-bar__list-item" *ngIf="hasLink" role="listitem">
                  <maced-link id="linkId1" [links]="link1" [showNextIconClass]="true" [nextIconClass]="nextIconClass">
                  </maced-link>
                </li>
                <li class="c-summary-bar__list-item" *ngIf="hasToggle" role="listitem">
                  <maced-toggle name="toggle1" id="toggle1" [textOn]="toggleText"
                    class="c-summary-bar__list-item-toggle"
                    [ariaLabel]="toggleNgModel ? 'toggle button switch on' : 'toggle button switch off'"
                    [(ngModel)]="toggleNgModel">
                  </maced-toggle>
                </li>
              </ul>
            </div>
          </maced-accordian>
        </maced-accordian-group>
      </ng-container>
    </ng-container>
  </maced-summary-bar>
</div>